<script lang="ts" setup>
const props = defineProps({
  linkTitle: String,
  icon: {
    type: String,
    default: 'icon-arrow-right3'
  }
})
</script>

<template>
  <nuxt-link class="link">
    <div class="link__title" v-if="props.linkTitle">{{ props.linkTitle }}</div>
    <div class="link__icon">
      <svg-icon :name="props.icon" />
    </div>
  </nuxt-link>
</template>

<style lang="scss" scoped>
.link {
  display: inline-flex;
  align-items: center;
  background-color: $color-gray-3;
  padding: toRem(12) toRem(24);
  &__title {
    margin-right: toRem(6);
    font-size: toRem(16);
    font-weight: 400;
    line-height: 1.45;
  }
  &__icon {
    width: toRem(24);
    height: toRem(24);
    color: $color-gray-1;
    svg {
      width: toRem(24);
      height: toRem(24);
    }
  }
}
</style>
